// extracted by mini-css-extract-plugin
module.exports = {"container":"InvoiceInfo_container__s5bWk","text":"InvoiceInfo_text__TcAO9"};